var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.getSign
    ? _c("div", [
        _c("div", { staticClass: "more-product-information-trigger" }, [
          _c(
            "button",
            {
              staticClass: "button",
              class: _vm.showProductInformation && "active",
              attrs: { role: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.showProductInformation = !_vm.showProductInformation
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.languageStrings.show_product_information) +
                  "\n    "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.getSign
          ? _c(
              "div",
              {
                staticClass: "column is-full more-product-information",
                class: _vm.showProductInformation ? "show" : null,
              },
              [
                _c("div", { staticClass: "columns is-multiline" }, [
                  _c(
                    "div",
                    { staticClass: "column base-information__description" },
                    [
                      _c("div", { staticClass: "base-information" }, [
                        _c("div", [
                          _vm.getSign.description
                            ? _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.parseSignDescription),
                                },
                              })
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.languageStrings.terms && _vm.settings.termspage
                        ? _c("div", { staticClass: "mt-2" }, [
                            _c(
                              "a",
                              { attrs: { href: _vm.settings.termspage } },
                              [_vm._v(_vm._s(_vm.languageStrings.terms))]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "column column base-information__technical",
                    },
                    [
                      _c("div", { staticClass: "terms" }, [
                        _vm.getSign.saleprice !== "0"
                          ? _c("div", { staticClass: "table-layout" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v(_vm._s(_vm.languageStrings.base_price)),
                              ]),
                              _vm._v(" "),
                              _vm.getSign.saleprice
                                ? _c("div", { staticClass: "label" }, [
                                    _vm.getSign.saleprice
                                      ? _c(
                                          "div",
                                          { staticClass: "is-size-4" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "price" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "price__original",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.getSign.price)
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getSign.saleprice
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _vm.languageStrings
                                                  .currency_symbol
                                                  ? _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.languageStrings
                                                            .currency_symbol
                                                        ),
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.calculateVat(
                                            _vm.getSign.saleprice
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.languageStrings.ex_vat
                                      ? _c(
                                          "span",
                                          { staticClass: "is-size-7" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.languageStrings.ex_vat)
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ])
                          : _c("div", { staticClass: "table-layout" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v(_vm._s(_vm.languageStrings.base_price)),
                              ]),
                              _vm._v(" "),
                              _vm.getSign.price
                                ? _c("div", { staticClass: "is-size-4" }, [
                                    _c("span", { staticClass: "price" }, [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.getSign.price)),
                                      ]),
                                      _vm._v(" "),
                                      _vm.languageStrings.currency_symbol
                                        ? _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.languageStrings
                                                  .currency_symbol
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    _vm.getSign.price
                                      ? _c("span", [
                                          _c(
                                            "span",
                                            { staticClass: "is-size-7" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.calculateVat(
                                                    _vm.getSign.price
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.languageStrings.ex_vat
                                            ? _c(
                                                "span",
                                                { staticClass: "is-size-7" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.languageStrings.ex_vat
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]),
                        _vm._v(" "),
                        _vm.languageStrings.sku && _vm.getSign.sku
                          ? _c("div", { staticClass: "table-layout mb-2" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v(_vm._s(_vm.languageStrings.sku)),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.getSign.sku))]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.languageStrings.material
                          ? _c("div", { staticClass: "table-layout mb-2" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v(
                                  _vm._s(_vm.languageStrings.material_title)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(_vm.languageStrings.color)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-layout mt-2" }, [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(_vm._s(_vm.languageStrings.size)),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.getSign.width) +
                                " x " +
                                _vm._s(_vm.getSign.height) +
                                " mm"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.languageStrings.color
                          ? _c("div", { staticClass: "table-layout mt-2" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v(_vm._s(_vm.languageStrings.variant)),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(_vm.languageStrings.material)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getSign.interfaces
                          ? _c("div", { staticClass: "table-layout mt-2" }, [
                              _vm.languageStrings.interface_application
                                ? _c("div", { staticClass: "label" }, [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.languageStrings
                                            .interface_application
                                        )
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "ul",
                                  _vm._l(
                                    _vm.getInterfaces(),
                                    function (interfaceItem, index) {
                                      return _c(
                                        "li",
                                        { key: index },
                                        [
                                          interfaceItem ===
                                            "sign_interface_tape" &&
                                          _vm.languageStrings
                                            .sign_interface_tape
                                            ? [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.languageStrings
                                                        .sign_interface_tape
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          interfaceItem ===
                                            "sign_interface_militaryclip" &&
                                          _vm.languageStrings
                                            .sign_interface_militaryclip
                                            ? [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.languageStrings
                                                        .sign_interface_militaryclip
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          interfaceItem ===
                                            "sign_interface_screw" &&
                                          _vm.languageStrings
                                            .sign_interface_screws
                                            ? [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.languageStrings
                                                        .sign_interface_screws
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          interfaceItem ===
                                            "sign_interface_safetypin" &&
                                          _vm.languageStrings
                                            .sign_interface_safetypin
                                            ? [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.languageStrings
                                                        .sign_interface_safetypin
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          interfaceItem ===
                                            "sign_interface_metalmagnet" &&
                                          _vm.languageStrings
                                            .sign_interface_metalmagnet
                                            ? [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.languageStrings
                                                        .sign_interface_metalmagnet
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          interfaceItem ===
                                            "sign_interface_plasticmagnet" &&
                                          _vm.languageStrings
                                            .sign_interface_plasticmagnet
                                            ? [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.languageStrings
                                                        .sign_interface_plasticmagnet
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          interfaceItem ===
                                            "sign_interface_keyring" &&
                                          _vm.languageStrings
                                            .sign_interface_keyring
                                            ? [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.languageStrings
                                                        .sign_interface_keyring
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-2" }, [
                        _c("ul", [
                          _vm.languageStrings.in_stock
                            ? _c("li", { staticClass: "in-stock mt-1" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.languageStrings.in_stock) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.languageStrings.tape_included &&
                          _vm.getSign.hasholes !== "1"
                            ? _c("li", { staticClass: "mt-1" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "product-promises-item tape-included",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.languageStrings.tape_included
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.languageStrings.screws_included &&
                          _vm.getSign.hasholes === "1"
                            ? _c("li", { staticClass: "mt-1" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "product-promises-item screws-included",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.languageStrings.screws_included
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.languageStrings.delivery_times
                            ? _c("li", { staticClass: "mt-1" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.languageStrings.delivery_times) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.languageStrings.large_orders
                            ? _c("li", { staticClass: "mt-1" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.languageStrings.large_orders) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.languageStrings.reservation
                    ? _c("div", { staticClass: "column is-full" }, [
                        _c("div", { staticClass: "mt-2" }, [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.languageStrings.reservation) +
                                "\n          "
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }